export const searchTermsByCategory = {
  'Baugewerbe & Sanierung': [
    'Sanierung von Schulgebäuden',
    'Installation von Photovoltaikanlagen',
    'Einbau von Sicherheitstüren',
    'Erneuerung der Straßenbeleuchtung',
    'Austausch von Heizungsanlagen',
    'Dachsanierung öffentlicher Gebäude',
    'Asphaltierung von Parkplätzen',
    'Errichtung von Lärmschutzwänden',
    'Modernisierung von Sportanlagen',
    'Sanierung von Schwimmbädern',
  ],
  'Technische Ausstattung & IT': [
    'Lieferung von Schulcomputern',
    'Installation von Videoüberwachung',
    'Einrichtung von WLAN-Netzen',
    'Beschaffung von Telefonanlagen',
    'Ausstattung digitaler Klassenzimmer',
    'Modernisierung der Serverinfrastruktur',
    'Installation von Zugangskontrollsystemen',
    'Lieferung von Druckern und Kopierern',
    'Beschaffung von Tablets für Schulen',
    'Einrichtung von Smart-Building-Systemen',
  ],
  'Dienstleistungen & Services': [
    'Reinigung von Verwaltungsgebäuden',
    'Pflege von Grünanlagen',
    'Winterdienst für öffentliche Einrichtungen',
    'Catering für Schulkantinen',
    'Wartung von Aufzugsanlagen',
    'Entsorgung von Büroabfällen',
    'Sicherheitsdienste für Behörden',
    'Transport von Schülern',
    'Wartung von Klimaanlagen',
    'Reinigung von Fassaden',
  ],
  'Spezialausrüstung & Fahrzeuge': [
    'Beschaffung von Feuerwehrfahrzeugen',
    'Lieferung von Rettungswagen',
    'Anschaffung von Kehrmaschinen',
    'Beschaffung von Müllfahrzeugen',
    'Lieferung von Kommunalfahrzeugen',
    'Beschaffung von Schneeräumgeräten',
    'Ausstattung von Polizeifahrzeugen',
    'Lieferung von Elektrofahrzeugen',
    'Anschaffung von Baumaschinen',
    'Beschaffung von Spezialwerkzeugen',
  ],
  'Planung & Beratung': [
    'Erstellung von Bebauungsplänen',
    'Durchführung von Umweltgutachten',
    'Beratung zur Energieeffizienz',
    'Verkehrsplanung für Innenstädte',
    'Machbarkeitsstudien für Bauvorhaben',
    'Projektsteuerung für Schulneubauten',
    'Brandschutzkonzepte für öffentliche Gebäude',
    'Statische Berechnungen für Brücken',
    'Entwicklung von Klimaschutzkonzepten',
    'Planung von Radwegenetzen',
  ],
};
